import { useEffect } from 'react';

export const useChatDraft = (chatId, { watch, setValue, reset }) => {
  const message = watch('message');

  const DRAFT_KEY = `chat_draft_${chatId}`;

  // Load draft when chat changes
  useEffect(() => {
    if (!chatId) return;

    const savedDraft = localStorage.getItem(DRAFT_KEY);
    if (savedDraft) {
      try {
        const draft = JSON.parse(savedDraft);
        setValue('message', draft.message || '');
        // Add any other fields you want to save
        // setValue('price', draft.price || '');
      } catch (error) {
        console.error('Failed to load draft:', error);
      }
    } else {
      // Clear the form when switching to a chat with no draft
      setValue('message', '');
    }
  }, [chatId, setValue, DRAFT_KEY]);

  // Save draft on message change (debounced)
  useEffect(() => {
    if (!chatId) return;

    const timeoutId = setTimeout(() => {
      if (message) {
        const draft = {
          message,
          // Add any other fields you want to save
          // price: watch('price'),
          timestamp: new Date().toISOString(),
        };
        localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
      } else {
        // Remove draft if message is empty
        localStorage.removeItem(DRAFT_KEY);
      }
    }, 500); // Debounce for 500ms

    return () => clearTimeout(timeoutId);
  }, [message, chatId, DRAFT_KEY]);

  // Clear draft function (call this on submit)
  const clearDraft = () => {
    if (!chatId) return;
    localStorage.removeItem(DRAFT_KEY);
    reset(); // Reset the entire form
  };

  return { clearDraft };
};
